import { styled, rippleMixin, css } from "../../../styled-components";

export const IOSWrapper = styled.div<{ isTabletDetail: boolean }>`
    height: ${p => p.theme.pivot.height}px;
    min-height: ${p => p.theme.pivot.height}px;

    border-width: 1px;
    border-color: ${p => p.theme.navBar.fgColor};
    border-radius: 4px;
    border-style: solid;

    display: flex;
    justify-content: stretch;
    align-items: stretch;

    margin: 0 ${p => p.theme.pageMarginMedium}px ${p => p.theme.pivot.bottomMargin}px;

    ${p =>
        p.isTabletDetail &&
        css`
            width: 100%;
            margin: 0 auto;
            max-width: var(--maximum-detail-width);
        `}
`;

export const IOSItemWrapper = styled.div<{ isCurrent: boolean }>`
    min-width: 1px;
    width: 1px;

    flex-grow: 1;
    flex-shrink: 1;

    color: ${p => (p.isCurrent ? p.theme.navBar.bgColor : p.theme.navBar.fgColor)};

    background-color: ${p => (p.isCurrent ? p.theme.navBar.fgColor : "transparent")};

    ${p => p.theme.fontStyles.Body5}
    text-align: center;
    text-transform: lowercase;
    font-variant: small-caps;

    display: flex;
    justify-content: center;
    align-items: center;

    transition: background-color 0.2s, color 0.2s;
`;

export const AndroidWrapper = styled.div`
    position: relative;
    height: ${p => p.theme.pivot.height}px;
    min-height: ${p => p.theme.pivot.height}px;

    display: flex;
    justify-content: stretch;
    align-items: stretch;

    margin: 0 0 ${p => p.theme.pivot.bottomMargin}px 0;

    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.24);
`;

export const AndroidItemWrapper = styled.div<{ isCurrent: boolean }>`
    min-width: 1px;
    width: 1px;

    flex-grow: 1;
    flex-shrink: 1;

    color: ${p => p.theme.navBar.fgColor};

    ${p => p.theme.fontStyles.AccentCallout4}
    text-align: center;

    font-variant: all-small-caps;
    text-transform: lowercase;

    display: flex;
    justify-content: center;
    align-items: center;

    ${rippleMixin}
`;

export const BottomBar = styled.div<{ width: string; position: string }>`
    position: absolute;

    height: 2px;
    width: ${p => p.width};
    bottom: 0;
    left: 0;

    background-color: ${p => p.theme.navBar.fgColor};

    transform: translateX(${p => p.position});

    transition: transform 0.2s;
`;
